export enum EChatsActionTypes {
  MessageSent = 'IChatMessageSent',
  StateReceived = 'IChatsStateReceived',
  OfferChatReceived = 'IOfferChatReceived',
}

export type TChatAction = IChatsStateReceived | IOfferChatReceived | IChatMessageSent;

export interface IChatMessageSent {
  type: EChatsActionTypes.MessageSent;
}

export const chatMessageSent = (): IChatMessageSent => ({
  type: EChatsActionTypes.MessageSent,
});

export interface IChatsStateReceived {
  type: EChatsActionTypes.StateReceived;
  payload: {
    enabled: boolean;
  };
}

export const chatsStateReceived = (enabled: boolean): IChatsStateReceived => ({
  payload: { enabled },
  type: EChatsActionTypes.StateReceived,
});

export interface IOfferChatReceived {
  type: EChatsActionTypes.OfferChatReceived;
  payload: {
    chatId: string;
  };
}

export const offerChatReceived = (chatId: string): IOfferChatReceived => ({
  payload: { chatId },
  type: EChatsActionTypes.OfferChatReceived,
});
